define('responsive-gameday/views/Monitor/ViewModels/distributors/MatchupSummaryViewDistributor',['require','exports','module','GameDayCore','../../Events/ViewModelUpdateEvents','message-service/message-service','gameday-index-url-hasher/UrlHasher','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/datasources/Datasources','moment','./MatchupViewDistributor'],function(require,exports,module) {
	var GDC = require("GameDayCore"),
		UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
		MessageService = require("message-service/message-service"),
		UrlHasher = require( "gameday-index-url-hasher/UrlHasher" ),
		resourcePath = require( "gameday-resource-path/gameday-resource-path" ),
		Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
		Moment = require("moment"),
		MatchupViewDistributor = require( "./MatchupViewDistributor" );

	var gameData = {};

	function buildSendData(){

		gameData = GDC.getGameData();

		var dataPack = self.dataPack || {
				awayLines: [],
				homeLines: [],
				away 	: {},
				home 	:{},
				innings : [],
				game 	: {}
			},
			entries = {},
			inning,
			inningsLength,
			loseP, winP, saveP,
			play = gameData.play,
			game = gameData.game,
			linescore = gameData.linescore,
			boxscore = gameData.boxscore,
			seriesLabel = "series",
			seriesRecord,
			isPostponed = linescore && linescore.status === 'Postponed',
			isDelayed 	= linescore && (linescore.status === 'Delayed Start' || linescore.status === 'Delayed'),
			isCancelled = linescore && linescore.status === 'Cancelled',
			sport_code = linescore.home_sport_code;

		loseP = linescore.losing_pitcher;
		winP = linescore.winning_pitcher;
		saveP = linescore.save_pitcher;


		if(play){
			var matchupData = MatchupViewDistributor.buildData(gameData);

			dataPack.game.runners = {
	            first: play.offense.first && play.offense.first.boxname,
	            second: play.offense.second && play.offense.second.boxname,
	            third: play.offense.third && play.offense.third.boxname,
	            mini: {
	                first: play.offense.first ? 'active' : '',
	                second: play.offense.second ? 'active' : '',
	                third: play.offense.third ? 'active' : ''
	            }
	        };
	        
            dataPack.matchup = matchupData.matchup;
		}
		// Adding pitcher data
		if((loseP && loseP.id) && (winP && winP.id)) {
			dataPack.losingPitcher = {
				pid: loseP.id,
				last_name: loseP.last,
				losses: loseP.losses,
				wins: loseP.wins,
				era: loseP.era,
				careerLink : resourcePath.get("externalPlayerCardLink",{pid : loseP.id})
			};

			dataPack.winningPitcher = {
				pid: winP.id,
				last_name: winP.last,
				losses: winP.losses,
				wins: winP.wins,
				era: winP.era,
				careerLink : resourcePath.get("externalPlayerCardLink",{pid : winP.id})
			};
		}
		if (saveP && saveP.id) {
			dataPack.savePitcher = {
				pid: saveP.id,
				last_name: saveP.last,
				saves: saveP.saves,	
				careerLink : resourcePath.get("externalPlayerCardLink",{pid : saveP.id})
			};
		}
		if(linescore.home_run_hitters && linescore.home_run_hitters.hasHomeruns){
			dataPack.homeRunHitters = linescore.home_run_hitters;
		}

		dataPack.formattedDate = Moment(linescore.time_date).format("dddd, MMMM D, YYYY"),
		dataPack.viewHighlightsLink = resourcePath.get("highlightsLink",{ game_pk : linescore.game_pk});

		// Add each team's stat information
		dataPack.away = {
			abbrev: game.away.abbrev.toLowerCase(),
			code: game.away.file_code,
			team_code: game.away.code,
			id  : game.away.id,
			name_brief: sport_code == "mlb" ? game.away.name_brief || game.away.name : game.away.name,
			runs: boxscore.away_runs,
			hits: boxscore.away_hits,
			errors: boxscore.away_errors,
			records: {
				wins: boxscore.away_wins,
				loss: boxscore.away_loss
			},
			headerLogo : resourcePath.get('teamLogoLarge',{code : game.away.code, file_code : game.away.file_code, sport_code : linescore.away_sport_code}),
			headerLogoDefault : resourcePath.get('teamLogoLargeGeneric',{code : game.away.code, file_code : game.away.file_code, sport_code : linescore.away_sport_code})
		};
		dataPack.home = {
			abbrev: game.home.abbrev.toLowerCase(),
			code: game.home.file_code,
			team_code: game.home.code,
			id  : game.home.id,
			name_brief: sport_code == "mlb" ? game.home.name_brief || game.home.name : game.home.name,
			runs: boxscore.home_runs,
			hits: boxscore.home_hits,
			errors: boxscore.home_errors,
			records: {
				wins: boxscore.home_wins,
				loss: boxscore.home_loss
			},
			venue: game.stadium.name,
			headerLogo : resourcePath.get('teamLogoLarge',{code : game.home.code, file_code : game.home.file_code, sport_code : linescore.home_sport_code}),
			headerLogoDefault : resourcePath.get('teamLogoLargeGeneric',{code : game.home.code, file_code : game.home.file_code, sport_code : linescore.home_sport_code})
		};
		dataPack.teams = {
			home: dataPack.home,
			away: dataPack.away
		};

		dataPack.game.innings = {
            state: matchupData.matchup.inningsState,
            stateShort: linescore.status_ind
        }

        dataPack.game.displayStatus = (isDelayed && 'Delayed' || isPostponed && "Postponed" || isCancelled && "Cancelled" || "");
        if(dataPack.game.displayStatus && linescore.status_reason){
			dataPack.game.displayStatus += (" - " + linescore.status_reason);
		} 
		
		dataPack.winnerFirstHeader = (~~dataPack.home.runs > ~~dataPack.away.runs) ? [dataPack.home, dataPack.away] : [dataPack.away, dataPack.home];
		dataPack.header = [dataPack.away, dataPack.home];

		// Add linescore data for each inning
		dataPack.linescore = boxscore.linescore;
		dataPack.linescore.displayFinalStatus = linescore.displayFinalStatus;
		dataPack.linescore.displayFinalStatusShort = linescore.displayFinalStatusShort;
		dataPack.linescore.record = boxscore.linescore;
		inningsLength = dataPack.linescore.record = boxscore.linescore.inning_line_score.length;
		seriesLabel = linescore.game_type === 'F' && 'Wild Card' || seriesLabel;
		seriesRecord = dataPack.header[0].records.wins * 1 > dataPack.header[1].records.wins * 1 ? [0, 1] : [1, 0];
		MessageService.publish(UpdateEvents.UPDATE_TEAM_MATCHUP_SUMMARY, dataPack);
	}

	exports.setGameData = function(game, scenes) {
		gameData = game || gameData;

		var liveState = UrlHasher.getHashParams().game_state;

		// If it's live or wrapup, dispatch data. If its not, only dispatch when requested.
		if(liveState == 'Live' || liveState == 'Wrapup'){
			this.prepareForDispatch();
		}

		MessageService.off(UpdateEvents.REQUEST_TEAM_MATCHUP_SUMMARY, exports.handleUpdateRequest);
		MessageService.on.call(this, UpdateEvents.REQUEST_TEAM_MATCHUP_SUMMARY, exports.handleUpdateRequest);
	};


	exports.prepareForDispatch = function() {
		if(gameData.linescore.game_pk !== GDC.getGameData().linescore.game_pk) {
			// wrong game, wait for further updates
			return;
		}

		MessageService.one.call(this,GDC.requestGameData(Datasources.GAMECENTER),buildSendData);
	};

	exports.handleUpdateRequest = function() {
		gameData = GDC.getGameData();
		this.prepareForDispatch();
	}

});
